import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    list: [],
    item: {},
    page: 1,
    total: null,
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.FINANCE_OPERATION_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.FINANCE_OPERATION_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                list: _addTotals(action.items.items, action.items.totals),
                page: action.items.page,
                total: getTotalPages(action.items.total, action.items.count)
            };

        case AppConstants.FINANCE_OPERATION_SEARCH_ITEM_SUCCESS:
            return {
                ...state,
                loading: false,
                item: action.items.items[0] || {}
            };

        default:
            return state;
    }
};

const _addTotals = (list, totals) => {
    if (!list.length) {
        return list;
    }

    let newList = [
        ...list,
        totals
    ];

    return newList;
};
